<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <h6>Lista de Diseños</h6>

            <!-- Columna de búsqueda -->
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input type="text" v-model="searchQuery" id="searchQuery" class="form-control"
                  placeholder="Buscar modelo..." @input="fetchData(null)" />
              </div>
            </div>

          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">

              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Modelo</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ref</th>
                    <!-- <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Stock
                    </th> -->
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Costo
                      por unidad</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ultima
                      modificación</th>
                    <th class="text-secondary text-center">
                      <router-link :to="{ name: 'Models Create' }" class="text-secondary font-weight-bold text-xs"
                        data-toggle="tooltip" data-original-title="Agregar protecto">
                        Agregar <i class="fa fa-plus"></i>
                      </router-link>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">

                    <td class="text-wrap align-top" style="white-space: normal; overflow-wrap: break-word;">
                      <div class="px-2 py-1">
                        <h6 class="mb-1 text-sm">{{ formatDesc(`${value.id} – ${value.name}`) }}</h6>
                        <p class="text-xs text-secondary mb-0">{{ formatDesc(value.description) }}</p>
                      </div>
                    </td>
                    <td class="text-wrap align-top" style="white-space: normal; overflow-wrap: break-word;">
                      <div class="px-2 py-1">
                        <h6 class="mb-0 text-sm">{{ formatDesc(value.ref) }}</h6>
                      </div>
                    </td>


                    <!--
                      <td>
                        <div class="px-2 py-1">
                          <div class="justify-content-center text-center">
                            <h6 class="mb-0 text-sm text-center">{{ value.total_quantity }}</h6>
                          </div>
                        </div>
                      </td>
                    -->

                    <td class="align-middle text-center text-sm">
                      {{ parseFloat(value.price).toLocaleString('es-ES', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }) }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm" :class="{
                        'bg-gradient-success': getStatus(value) === 0, // Aprobado
                        'bg-gradient-warning': getStatus(value) === 1, // En mejora
                        'bg-gradient-danger': getStatus(value) === 2  // Rechazado
                      }">
                        {{ getStatusText(value) }}
                      </span>
                    </td>

                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ new Date(value.updated_at).toLocaleDateString('es-ES') }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <router-link :to="{ name: 'Models Create', params: { data: JSON.stringify(value) }, props: true }"
                        class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                        data-original-title="Editar Registro">
                        <i class="fa fa-pencil-alt"></i>
                      </router-link>


                      <a @click="deleteUser(value.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;" data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>

                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="7" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer" @click="fetchData(link.url)"
                  :disabled="!link.url || link.active" :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
export default {
  name: 'ProjectsList',
  data() {
    return {
      searchQuery: '',
    };
  },
  computed: {
    ...mapGetters('models', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']), // Mapea el getter allUsers
    currentPage() {
      return this.$store.state.models.currentPage; // Obtiene la página actual
    },
    lastPage() {
      return this.$store.state.models.lastPage; // Obtiene la última página
    },
    data() {
      return this.allData; // Retorna los usuarios desde el store
    },
    links() {
      return this.$store.getters['models/links']; // Retorna los links
    },
  },
  methods: {
    async fetchData(pageUrl = null) {
      const params = {
        search: this.searchQuery,
        page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1
      };
      await this.$store.dispatch('models/fetchData', params);
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("models/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            this.fetchData();

            await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el usuario');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    formatDesc(str = '') {
      if (!str) return ''
      // inserta doble salto de línea tras cada 80 chars
      return str.replace(/(.{32})/g, '$1\n\n')
    },
    getStatus(value) {
      // Convierte el status a número y maneja casos null/undefined
      const status = value?.status;
      if (status === null || status === undefined) return 1; // Por defecto "En mejora"
      return parseInt(status, 10);
    },
    getStatusText(value) {
      const status = this.getStatus(value);
      switch (status) {
        case 0:
          return 'Aprobado';
        case 1:
          return 'En mejora';
        case 2:
          return 'Rechazado';
        default:
          return 'En mejora';
      }
    }

  },
  mounted() {
    this.fetchData(); // Llama a fetchUsers cuando el componente se monta
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
  /* Estilo para la página activa */
}
</style>